<template>
  <App v-if="!isFullScreenError">
    <template #content>
      <AppError :server-error="!!error.data?.serverError" :code="errorCode" />
    </template>
  </App>
  <div v-else class="h-screen w-screen flex items-center justify-center">
    <AppError :server-error="!!error.data?.serverError" :code="errorCode" />
  </div>
</template>

<script setup lang="ts">
import App from '@@/app/layouts/default.vue'
const { post } = useApi()
const props = defineProps({
  error: {
    type: Object,
    required: true,
  },
})
console.log(props.error)

const route = useRoute()

const { $auth } = useNuxtApp()
const { checkSession } = $auth
const errorCode = computed(() => props.error?.cause?.code ?? props.error.statusCode)

const { moreErrors, someError } = useErrors()

const isFullScreenError = computed(
  () =>
    !!moreErrors.value ||
    (!someError.value && errorCode.value !== 404) ||
    (route.meta.layout && route.meta.layout !== 'default')
)

onBeforeMount(async () => {
  await checkSession()
  if ([404, 301, 302, 303, 304].includes(errorCode.value)) {
    await post('/public/urls', { url: window.location.href, type: errorCode.value })
  }
})
</script>
